<template>
<div class="chapter">
<div class="inner_page">
<h1>With Carson</h1>
<h1 class="sigil_not_in_toc">And Frémont</h1>
<h2 class="sigil_not_in_toc">Edwin L. Sabin</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?45a568a8